// extracted by mini-css-extract-plugin
module.exports = {"body":"BuildTeam_body__RvZPX","title":"BuildTeam_title__3QRBw","brand":"BuildTeam_brand__247XF","description":"BuildTeam_description__33-zv"};